import React, {Suspense, lazy} from 'react';
import {RootState} from '../store/store';
import {useSelector} from 'react-redux';

interface SidebarProps {
  setIsNewDrawerOpen: (isOpen: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({setIsNewDrawerOpen}) => {
  const activeApp = useSelector(
    (state: RootState) => state.appSwitch.activeApp,
  );

  const SidebarContent = lazy(
    () => import(`features/sidebar/${activeApp}/SidebarContent`),
  );
  const CompressedSidebarContent = lazy(
    () => import(`features/sidebar/${activeApp}/CompressedSidebarContent`),
  );

  return (
    <div className="z-10 flex-col justify-center items-start gap-[148px] inline-flex flex-grow">
      <div className="top-3 z-10"></div>
      <Suspense fallback={null}>
        <SidebarContent setIsNewDrawerOpen={setIsNewDrawerOpen} />
        <CompressedSidebarContent setIsNewDrawerOpen={setIsNewDrawerOpen} />
      </Suspense>
    </div>
  );
};

export default Sidebar;
